import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  width: 300px;
  .error {
    transform: translateY(-5px);
    font-size: 1rem;
    color: red;
  }
`;
